// const Swal = require('sweetalert2');
import Swal from "sweetalert2";
// import "../../css/Alerta.css"

const Alertas = {

    ExibirAlertaErro: function (Titulo) {
        const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.style.zIndex = '9999999'; // Garantir que o modal esteja sempre na frente
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
                toast.style.marginTop = '9px'; // Adicionando margem superior diretamente

            }
        });

        Toast.fire({
            icon: "error",
            title: Titulo
        });
    },

    ExibirAlertaSucesso: function (Titulo) {
        const Toast = Swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: false,
            timer: 1900,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
                toast.style.zIndex = '9999'; // Garantir que o modal esteja sempre na frente
                toast.style.marginTop = '9px'; // Adicionando margem superior diretamente
            }
        });

        Toast.fire({
            icon: "success",
            title: Titulo
        });
    },

    ExibirAlertaComConfirmacaoDoUsuario: function (Titulo) {
        Swal.fire({
            title: Titulo,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire("Confirmado!", "Você confirmou a ação.", "success");
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Cancelado!", "Ação foi cancelada.", "error");
            }
        });
    },


    RespostaDoAlerta: function (resposta) {

        if (resposta === "usuario_aceitou") {
            return 'usuario_aceitou';
        } else {
            return 'usuario_recusou'
        }

    },

    ExibirAlertaDecisao: async function (Titulo) {

        const result = await Swal.fire({
            title: "Atenção?",
            text: Titulo,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "Não",
            reverseButtons: true,
            confirmButtonText: "Sim",
            customClass: {
                container: 'swal2-custom-container'
            }
        });

        if (result.isConfirmed) {
            return 'usuario_aceitou';
        } else {
            return 'usuario_recusou';
        }
    },

    ExibirLoadingBuscaDeDadosTabela: async function (Titulo) {

        let timerInterval;
        Swal.fire({
            title: "Auto close alert!",
            html: "I will close in <b></b> milliseconds.",
            timer: 2000,
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading();
                const timer = Swal.getPopup().querySelector("b");
                timerInterval = setInterval(() => {
                    timer.textContent = `${Swal.getTimerLeft()}`;
                }, 100);
            },
            willClose: () => {
                clearInterval(timerInterval);
            }
        }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
                console.log("I was closed by the timer");
            }
        });
    }




};

export default Alertas;

